import { put, takeLatest } from 'redux-saga/effects';

import requestWrapper from 'utils/requestWrapper';
import { loginUserError, loginUserSuccess } from './actions';

import { LOGIN_USER } from './constants';


export function* loginUserSaga(action) {
  try {

    const { loginValues, isApp } = action;

    let body = {
      email: loginValues.username,
      password: loginValues.password,
      isApp: isApp
    };

    let response = null;
    // we try to log the user with the data from the form
    if (!!loginValues) {
      response = yield requestWrapper('POST', `auth/login`, body, '');
    }

    const currentUser = response?.user;
    if (!response || (response?.errors && !response?.user)) {
      if (response?.errors && !response?.user) {
        yield put(loginUserError(response?.errors));
      } else {
        yield put(loginUserError({
          message: `Login data is Empty.`
        }));
      }
      
    } else {

      if (currentUser?._id) {
        localStorage.setItem(
          'schoolinked_user',
          JSON.stringify({
            access_token: currentUser?.access_token,
            _id: currentUser?._id,
            token: currentUser?.token,
            role: currentUser?.role,
            confirmed: currentUser?.confirmed,
            lastOpenedApp: currentUser?.lastOpenedApp,
          }),
        );
        yield put(loginUserSuccess(currentUser, true));
      } else {
        console.warn('token expire', currentUser);
        yield put(loginUserSuccess(currentUser, false));
      }

    }

  } catch (err) {
    yield put(loginUserError(err));
  }
}

// Individual exports for testing
export default function* loginSaga() {
  yield takeLatest(LOGIN_USER, loginUserSaga);
}
